function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "twitter-white",
  transform: "translate(-376.747 -119.858)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Exclus\\xE3o_2",
  "data-name": "Exclus\\xE3o 2",
  d: "M15349.346,5484.689a7.677,7.677,0,1,1,7.678-7.678A7.684,7.684,0,0,1,15349.346,5484.689Zm-4.47-4.868h0a5.221,5.221,0,0,0,8.036-4.4c0-.068,0-.137-.007-.211v-.024a3.6,3.6,0,0,0,.913-.952,3.557,3.557,0,0,1-1.052.289,1.833,1.833,0,0,0,.81-1.014,3.7,3.7,0,0,1-1.168.447,1.832,1.832,0,0,0-3.172,1.252,1.938,1.938,0,0,0,.046.42,5.2,5.2,0,0,1-3.78-1.919,1.832,1.832,0,0,0,.566,2.451,1.8,1.8,0,0,1-.834-.231v.023a1.844,1.844,0,0,0,1.473,1.8,1.842,1.842,0,0,1-.481.065,1.7,1.7,0,0,1-.348-.035,1.842,1.842,0,0,0,1.716,1.275,3.663,3.663,0,0,1-2.282.787A3.989,3.989,0,0,1,15344.876,5479.821Z",
  transform: "translate(-14964.926 -5349.477)"
}));

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.351,
    height: 15.355,
    viewBox: "0 0 15.351 15.355",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.fd48ec0d.svg";
export { ForwardRef as ReactComponent };